import { render } from "./ScavengerHunt.vue?vue&type=template&id=2968bec2&scoped=true"
import script from "./ScavengerHunt.vue?vue&type=script&lang=js"
export * from "./ScavengerHunt.vue?vue&type=script&lang=js"

import "./ScavengerHunt.vue?vue&type=style&index=0&id=2968bec2&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2968bec2"]])

export default __exports__